import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { NEW_PROCESS_PATH, PROCESS_PATH } from '../../../../config/paths';
import { PROCESS_COLUMNS } from '../../../../config/columns';
import { clearProcesses, getProcesses } from '../../../../actions';

export const Processes = ({
  breadcrumbs,
  processes,
  loading,
  dispatchGetProcesses,
  dispatchClearProcesses,
}) => {
  useLayoutEffect(() => () => dispatchClearProcesses(), []);

  const data = processes.get('content') || [];
  const pages = processes.get('totalPages') || null;
  const defaultPageSize = processes.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Lista de Procesos"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_PROCESS_PATH}
      tableStructure={{
        columns: PROCESS_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetProcesses,
        modelPath: PROCESS_PATH,
        loading,
        navigateToModelOnRowClick: true,
        queryProps: 'active:true',
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetProcesses: getProcesses,
  dispatchClearProcesses: clearProcesses,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Procesos',
      href: PROCESS_PATH,
    },
  ],
  processes: ItineraryUnit.Process.getIn(['all', 'content']),
  loading: ItineraryUnit.Process.getIn(['all', 'loading']),
});

Processes.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  processes: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetProcesses: PropTypes.func.isRequired,
  dispatchClearProcesses: PropTypes.func.isRequired,
};

Processes.defaultProps = {
  processes: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Processes);
